import React from 'react';
import { useParams } from 'react-router-dom';
import { DocumentsList } from 'features/Documents/DocumentsList';

const ProductDocuments = () => {
  const { productId } = useParams<{ productId: string }>();

  return <DocumentsList id={productId} type="product" />;
};

export { ProductDocuments };
